import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Accordion, AccordionDetails, AccordionSummary} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const FilterGroupPanel = ({dataQe, title, ...props}) => {
  return (
    <Accordion
      defaultExpanded
      data-qe={dataQe}
      elevation={0}
      sx={{
        boxShadow: 'none',
      }}
      {...props}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{fontWeight: 'fontWeightMedium'}}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          paddingY: 0,
        }}
      >
        {props.children}
      </AccordionDetails>
    </Accordion>
  );
};

FilterGroupPanel.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  dataQe: PropTypes.string,
};

export default FilterGroupPanel;
